import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstance6abcr423wmp1 as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketEngine1lh73ie4wh0m5 as WebSocketEngine } from './WebSocketEngine.js.mjs';
import {
  Companion_getInstancevdtg3uvqmv7f as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstancesbkvvo7sip2d as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { GraphQLWsProtocol3nqe2321ot0cb as GraphQLWsProtocol } from './GraphQLWsProtocol.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import {
  awaitClose1zqdv98mnafc2 as awaitClose,
  ProducerScopeb3mmhvfa6ll7 as ProducerScope,
} from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { WebSocketPool28m608awosr6h as WebSocketPool } from './internal/WebSocketPool.mjs';
import { callbackFlow1g384rkuy0hni as callbackFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ChannelResult2y4k69ac6y3du as ChannelResult } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance4887rkxhu93r as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WebSocketNetworkTransport$Builder$build$slambdaClass;
function WebSocketNetworkTransport$Builder$build$slambda() {
  if (WebSocketNetworkTransport$Builder$build$slambdaClass === VOID) {
    class $ {
      *k6h($completion) {
        return null;
      }
      nd($completion) {
        return this.k6h($completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    WebSocketNetworkTransport$Builder$build$slambdaClass = $;
  }
  return WebSocketNetworkTransport$Builder$build$slambdaClass;
}
function WebSocketNetworkTransport$Builder$build$slambda_0() {
  var i = new (WebSocketNetworkTransport$Builder$build$slambda())();
  var l = ($completion) => i.k6h($completion);
  l.$arity = 0;
  return l;
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.s6a_1 = null;
        this.t6a_1 = null;
        this.u6a_1 = null;
        this.v6a_1 = null;
        this.w6a_1 = null;
        this.x6a_1 = null;
        this.y6a_1 = null;
        this.z6a_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
      }
      o6a(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.s6a_1 = serverUrl;
        return this;
      }
      a6b(idleTimeout) {
        // Inline function 'kotlin.apply' call
        this.x6a_1 = idleTimeout;
        return this;
      }
      l38() {
        var tmp0_elvis_lhs = this.t6a_1;
        var tmp5_webSocketEngine = tmp0_elvis_lhs == null ? WebSocketEngine() : tmp0_elvis_lhs;
        var tmp6_serverUrl = this.s6a_1;
        var tmp1_elvis_lhs = this.x6a_1;
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new (Duration())(tmp_0)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp = toDuration(60, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp7_idleTimeout = tmp;
        var tmp2_elvis_lhs = this.u6a_1;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          tmp_1 = new (GraphQLWsProtocol())(WebSocketNetworkTransport$Builder$build$slambda_0());
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var tmp8_wsProtocol = tmp_1;
        var tmp9_pingInterval = this.w6a_1;
        var tmp3_elvis_lhs = this.v6a_1;
        var tmp_2;
        var tmp_3 = tmp3_elvis_lhs;
        if ((tmp_3 == null ? null : new (Duration())(tmp_3)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp_2 = toDuration(10, DurationUnit_SECONDS_getInstance());
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var tmp10_connectionAcknowledgeTimeout = tmp_2;
        var tmp4_elvis_lhs = this.y6a_1;
        var tmp11_parserFactory = tmp4_elvis_lhs == null ? new (DefaultSubscriptionParserFactory())(get_impl(this.z6a_1)) : tmp4_elvis_lhs;
        return new (WebSocketNetworkTransport())(tmp5_webSocketEngine, tmp6_serverUrl, tmp8_wsProtocol, tmp10_connectionAcknowledgeTimeout, tmp9_pingInterval, tmp7_idleTimeout, tmp11_parserFactory);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
var WebSocketNetworkTransport$execute$slambdaClass;
function WebSocketNetworkTransport$execute$slambda() {
  if (WebSocketNetworkTransport$execute$slambdaClass === VOID) {
    class $ {
      constructor($renewUuid, $request, this$0) {
        this.l6h_1 = $renewUuid;
        this.m6h_1 = $request;
        this.n6h_1 = this$0;
      }
      *e6a($this$callbackFlow, $completion) {
        var tmp;
        if (this.l6h_1._v) {
          tmp = this.m6h_1.h45().b44(uuid4()).l38();
        } else {
          tmp = this.m6h_1;
        }
        var newRequest = tmp;
        this.l6h_1._v = true;
        var operationListener = new (DefaultOperationListener())(newRequest, $this$callbackFlow, this.n6h_1.u6h_1.w6h(this.m6h_1));
        var webSocket = this.n6h_1.v6h_1.f6i(newRequest);
        webSocket.t6i(newRequest, operationListener);
        yield* awaitClose($this$callbackFlow, () => {
          webSocket.u6i(newRequest);
          return Unit_instance;
        }, $completion);
        return Unit_instance;
      }
      od(p1, $completion) {
        return this.e6a((!(p1 == null) ? isInterface(p1, ProducerScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    WebSocketNetworkTransport$execute$slambdaClass = $;
  }
  return WebSocketNetworkTransport$execute$slambdaClass;
}
function WebSocketNetworkTransport$execute$slambda_0($renewUuid, $request, this$0) {
  var i = new (WebSocketNetworkTransport$execute$slambda())($renewUuid, $request, this$0);
  var l = ($this$callbackFlow, $completion) => i.e6a($this$callbackFlow, $completion);
  l.$arity = 1;
  return l;
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, wsProtocol, connectionAcknowledgeTimeout, pingInterval, idleTimeout, parserFactory) {
        this.o6h_1 = webSocketEngine;
        this.p6h_1 = serverUrl;
        this.q6h_1 = wsProtocol;
        this.r6h_1 = connectionAcknowledgeTimeout;
        this.s6h_1 = pingInterval;
        this.t6h_1 = idleTimeout;
        this.u6h_1 = parserFactory;
        this.v6h_1 = new (WebSocketPool())(this.o6h_1, this.p6h_1, this.q6h_1, this.r6h_1, this.s6h_1, this.t6h_1);
      }
      v6b(request) {
        var renewUuid = {_v: false};
        var flow = callbackFlow(WebSocketNetworkTransport$execute$slambda_0(renewUuid, request, this));
        return buffer(flow, 2147483647);
      }
      xz() {
        this.v6h_1.l6();
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport');
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
function errorResponse($this, cause) {
  return Builder().s45($this.v6i_1.r44_1, $this.v6i_1.s44_1).x45(cause).l38();
}
var DefaultOperationListenerClass;
function DefaultOperationListener() {
  if (DefaultOperationListenerClass === VOID) {
    class $ {
      constructor(request, producerScope, parser) {
        this.v6i_1 = request;
        this.w6i_1 = producerScope;
        this.x6i_1 = parser;
      }
      y6i(response) {
        var tmp0_safe_receiver = this.x6i_1.z6i(response);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = this.w6i_1.h1b(tmp0_safe_receiver);
          new (ChannelResult())(tmp$ret$0);
        }
      }
      a6j() {
        this.w6i_1.s1b();
      }
      b6j(payload) {
        this.w6i_1.h1b(errorResponse(this, SubscriptionOperationException().l4i(this.v6i_1.r44_1.operationName(), payload)));
        this.w6i_1.s1b();
      }
      c6j(cause) {
        this.w6i_1.h1b(errorResponse(this, cause));
        this.w6i_1.s1b();
      }
    }
    initMetadataForClass($, 'DefaultOperationListener');
    DefaultOperationListenerClass = $;
  }
  return DefaultOperationListenerClass;
}
var DefaultSubscriptionParserFactoryClass;
function DefaultSubscriptionParserFactory() {
  if (DefaultSubscriptionParserFactoryClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl) {
        this.d6j_1 = incrementalDeliveryProtocolImpl;
      }
      w6h(request) {
        return new (DefaultSubscriptionParser())(this.d6j_1, request);
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParserFactory');
    DefaultSubscriptionParserFactoryClass = $;
  }
  return DefaultSubscriptionParserFactoryClass;
}
var DefaultSubscriptionParserClass;
function DefaultSubscriptionParser() {
  if (DefaultSubscriptionParserClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl, request) {
        this.e6j_1 = request;
        this.f6j_1 = incrementalDeliveryProtocolImpl.y6d();
        var tmp = this;
        var tmp0_elvis_lhs = this.e6j_1.t44_1.q49(Key_getInstance());
        tmp.g6j_1 = tmp0_elvis_lhs == null ? Key_getInstance().d49_1 : tmp0_elvis_lhs;
      }
      z6i(response) {
        var responseMap = (!(response == null) ? isInterface(response, KtMap()) : false) ? response : null;
        if (responseMap == null) {
          return Builder().s45(this.e6j_1.r44_1, this.e6j_1.s44_1).x45(DefaultApolloException().n46('Invalid payload')).l38();
        }
        var tmp;
        if (isDeferred(responseMap)) {
          tmp = to(this.f6j_1.k6e(responseMap), this.f6j_1.g6e());
        } else {
          tmp = to(responseMap, null);
        }
        var _destruct__k2r9zo = tmp;
        var payload = _destruct__k2r9zo.ze();
        var deferredFragmentIdentifiers = _destruct__k2r9zo.af();
        var apolloResponse = toApolloResponse(jsonReader(payload), this.e6j_1.r44_1, this.e6j_1.s44_1, this.g6j_1, deferredFragmentIdentifiers);
        if (!this.f6j_1.h6e()) {
          this.f6j_1.j3p();
        }
        var tmp_0;
        if (this.f6j_1.i6e()) {
          tmp_0 = null;
        } else {
          tmp_0 = apolloResponse;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParser');
    DefaultSubscriptionParserClass = $;
  }
  return DefaultSubscriptionParserClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.v4().t2('hasNext');
}
//region block: exports
export {
  Builder_0 as Builder1suvx83rlbrz1,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
